export const CRM_POSTVENTA_V2_SECTIONS = [
  {
    slug: "onboarding",
    processCode: "ONBOARDING_V2",
    title: "Onboarding",
    shortTitle: "Onboarding",
    description: "Alta, checklist obligatorio y derivación inicial.",
    actionLabel: "Generar onboarding",
    supportsGenerate: true,
    supportsReconcile: false,
    isSpecial: false,
  },
  {
    slug: "zoco-check",
    processCode: "ZOCO_CHECK_V2",
    title: "Zoco Check",
    shortTitle: "Zoco Check",
    description: "Seguimiento semanal por comercio derivado desde onboarding.",
    actionLabel: "Generar ciclos",
    supportsGenerate: true,
    supportsReconcile: false,
    isSpecial: false,
  },
  {
    slug: "terminal-sin-facturacion",
    processCode: "TERMINAL_SIN_FACTURACION_V2",
    title: "Terminal sin facturación",
    shortTitle: "Sin facturación",
    description: "Monitoreo operativo por terminal con estados inteligentes.",
    actionLabel: "Detectar terminales",
    supportsGenerate: true,
    supportsReconcile: false,
    isSpecial: false,
  },
  {
    slug: "recupero-terminal",
    processCode: "RECUPERO_TERMINAL_V2",
    title: "Recupero de terminal",
    shortTitle: "Recupero",
    description: "Recupero escalonado con reconciliación administrativa.",
    actionLabel: "Reconciliar recupero",
    supportsGenerate: false,
    supportsReconcile: true,
    isSpecial: false,
  },
  {
    slug: "terminal-extraviada",
    processCode: "TERMINAL_EXTRAVIADA_V2",
    title: "Terminal extraviada",
    shortTitle: "Extraviada",
    description: "Gestión crítica con evidencias y cola de compliance.",
    actionLabel: "Reconciliar extraviadas",
    supportsGenerate: false,
    supportsReconcile: true,
    isSpecial: false,
  },
  {
    slug: "automatizacion",
    title: "Automatización CRM Postventa",
    shortTitle: "Automatización",
    description: "Estado, historial y ejecución manual segura del scheduler interno.",
    supportsGenerate: false,
    supportsReconcile: false,
    isSpecial: true,
  },
  {
    slug: "derivaciones",
    title: "Derivaciones",
    shortTitle: "Derivaciones",
    description: "Instancias derivadas a otros procesos o sectores.",
    supportsGenerate: false,
    supportsReconcile: false,
    isSpecial: true,
  },
  {
    slug: "historial",
    title: "Historial operativo",
    shortTitle: "Historial",
    description: "Vista consolidada de colas activas para seguimiento y auditoría.",
    supportsGenerate: false,
    supportsReconcile: false,
    isSpecial: true,
  },
];

export const getSectionMeta = (slug) =>
  CRM_POSTVENTA_V2_SECTIONS.find((item) => item.slug === slug) || CRM_POSTVENTA_V2_SECTIONS[1];

export const getProcessCodeBySlug = (slug) =>
  CRM_POSTVENTA_V2_SECTIONS.find((item) => item.slug === slug)?.processCode || "";

export const getSlugByProcessCode = (processCode) => {
  const normalized = String(processCode || "").toUpperCase();
  const byCode = {
    ONBOARDING_V2: "onboarding",
    ZOCO_CHECK_V2: "zoco-check",
    TERMINAL_SIN_FACTURACION_V2: "terminal-sin-facturacion",
    RECUPERO_TERMINAL_V2: "recupero-terminal",
    TERMINAL_EXTRAVIADA_V2: "terminal-extraviada",
  };

  return byCode[normalized] || "zoco-check";
};
